// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { getHeaders } from '../utils/apiUtils';
// import { FaSearch } from 'react-icons/fa';
// import './Autocomplete.css';
// import environment from "../environment";

// const Autocomplete = ({ onSelect, value: propValue = '' }) => {
//   const [inputValue, setInputValue] = useState(propValue);
//   const [suggestions, setSuggestions] = useState([]);
//   const [isOpen, setIsOpen] = useState(false);
//   const [isFocused, setIsFocused] = useState(false);
//   const justSelected = useRef(false);

//   // Update input value when prop changes
//   // useEffect(() => {
//   //   if (propValue && propValue !== inputValue) {
//   //     setInputValue(propValue);
//   //   }
//   // }, [propValue]);
//   useEffect(() => {
//   if (!isFocused || justSelected.current) return; // ← do not fetch after select

//   if (inputValue) {
//     const fetchSuggestions = async () => {
//       try {
//         const response = await axios.get(`${environment.apiurl_agentCode}hospitals/city/`, {
//           headers: getHeaders(),
//           params: {
//             filters: JSON.stringify([{ key: 'city', value: inputValue }])
//           }
//         });
//         setSuggestions(response?.data?.msg?.items || []);
//         setIsOpen(true);
//       } catch (error) {
//         console.error('Error fetching city data:', error);
//       }
//     };

//     const debounce = setTimeout(fetchSuggestions, 200);
//     return () => clearTimeout(debounce);
//   }

//   setSuggestions([]);
//   setIsOpen(false);
// }, [inputValue, isFocused]);


//   useEffect(() => {
//     if (inputValue && isFocused) {
//       const fetchSuggestions = async () => {
//         try {
//           const response = await axios.get(`${environment.apiurl_agentCode}hospitals/city/`, {
//             headers: getHeaders(),
//             params: {
//               'filters': JSON.stringify([{
//                 key: 'city',
//                 value: inputValue
//               }])
//             }
//           });
//           setSuggestions(response?.data?.msg?.items || []);
//           setIsOpen(true);
//         } catch (error) {
//           console.error('Error fetching city data:', error);
//         }
//       };

//       const debounceFetch = setTimeout(() => {
//         fetchSuggestions();
//       }, 0);

//       return () => clearTimeout(debounceFetch);
//     } else {
//       setSuggestions([]);
//       setIsOpen(false);
//     }
//   }, [inputValue]);

//   const handleSelect = (suggestion) => {
//     justSelected.current = true;
//     setInputValue(suggestion.city);
//     onSelect(suggestion.city);
//     setIsOpen(false);
//     // Clear the flag after a short delay to prevent race conditions
//     setTimeout(() => {
//       justSelected.current = false;
//     }, 100);
//   };

//   return (
//     <div className="autocomplete-container">
//       <div className="input-wrapper">
//         <input
//           type="text"
//           className="form-input"
//           placeholder="Search your city"
//           value={inputValue}
//           onChange={(e) => setInputValue(e.target.value)}
//           onFocus={() => {
//             setIsFocused(true);
//             if (justSelected.current) {
//               justSelected.current = false;
//               return;
//             }
//             setIsOpen(true);
//           }}
//           onBlur={(e) => {
//             // Check if the blur is caused by clicking outside the component
//             if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) {
//               setIsFocused(false);
//               // Close the dropdown with a small delay
//               setTimeout(() => {
//                 if (!justSelected.current) {
//                   setIsOpen(false);
//                 }
//               }, 200);
//             }
//           }}
//         />
//         <FaSearch className="search-icon" />
//       </div>
//       {isOpen && suggestions.length > 0 && (
//         <ul className="suggestions-list">
//           {suggestions.map((suggestion, index) => (
//             <li 
//               key={index}
//               onMouseDown={(e) => {
//                 // Use onMouseDown instead of onClick to ensure it fires before onBlur
//                 e.preventDefault();
//                 handleSelect(suggestion);
//               }}
//             >
//               {suggestion.city}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default Autocomplete;


import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { getHeaders } from '../utils/apiUtils';
import { FaSearch } from 'react-icons/fa';
import './Autocomplete.css';
import environment from "../environment";

// Map of city name variations to canonical names
const CITY_NAME_MAP = {
  'gurgaon': 'Gurugram',
  'gurugram': 'Gurugram',
  'bangalore': 'Bangalore',
  'bengaluru': 'Bangalore',
  'mumbai': 'Mumbai',
  'bombay': 'Mumbai',
  'calcutta': 'Kolkata',
  'kolkata': 'Kolkata',
  'madras': 'Chennai',
  'chennai': 'Chennai',
};

// Function to normalize city name for comparison
const normalizeCityName = (cityName) => {
  if (!cityName) return '';
  return cityName.trim().toLowerCase();
};

// Function to get canonical city name
const getCanonicalCityName = (cityName) => {
  const normalized = normalizeCityName(cityName);
  return CITY_NAME_MAP[normalized] || cityName.trim();
};

// Function to deduplicate cities and handle variations
const deduplicateCities = (cities) => {
  const cityMap = new Map();
  
  cities.forEach(item => {
    if (!item || !item.city) return;
    
    const cityName = item.city.trim();
   // const normalized = normalizeCityName(cityName);
    const canonical = getCanonicalCityName(cityName);
    const canonicalNormalized = normalizeCityName(canonical);
    
    // Use canonical normalized name as key to catch duplicates (e.g., Gurugram and Gurgaon)
    // Both "Gurugram" and "Gurgaon" map to "Gurugram", so they'll be deduplicated
    if (!cityMap.has(canonicalNormalized)) {
      cityMap.set(canonicalNormalized, {
        ...item,
        city: canonical
      });
    }
  });
  
  return Array.from(cityMap.values());
};

const Autocomplete = ({ onSelect, value: propValue = '' }) => {
  const [inputValue, setInputValue] = useState(propValue);
  const [suggestions, setSuggestions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const justSelected = useRef(false);

  // Sync input with parent - only update if propValue actually changes
  // useEffect(() => {
  //   if (propValue !== undefined && propValue !== inputValue && !justSelected.current) {
  //     setInputValue(propValue || '');
  //   }
  // }, [propValue]);
  useEffect(() => {
    if (propValue !== undefined && propValue !== inputValue && !justSelected.current) {
      setInputValue(propValue || '');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propValue]);


  // Fetch suggestions only when typing (not when value is already selected)
  useEffect(() => {
    if (!isFocused || justSelected.current) {
      setSuggestions([]);
      setIsOpen(false);
      return;
    }

    const trimmedValue = inputValue.trim();
    if (trimmedValue.length >= 2) { // Only search if at least 2 characters
      const fetchSuggestions = async () => {
        try {
          const response = await axios.get(
            `${environment.apiurl_agentCode}hospitals/city/`,
            {
              headers: getHeaders(),
              params: {
                filters: JSON.stringify([
                  { key: 'city', value: trimmedValue }
                ]),
              },
            }
          );

          // Filter out invalid/empty city names
          const validSuggestions = (response?.data?.msg?.items || []).filter(
            item => item && item.city && item.city.trim() !== ''
          );
          
          // Deduplicate cities and handle known variations (e.g., Gurugram/Gurgaon)
          const uniqueSuggestions = deduplicateCities(validSuggestions);
          
          setSuggestions(uniqueSuggestions);
          setIsOpen(uniqueSuggestions.length > 0);
        } catch (error) {
          console.error('Error fetching city data:', error);
          setSuggestions([]);
          setIsOpen(false);
        }
      };

      const debounce = setTimeout(fetchSuggestions, 300);
      return () => clearTimeout(debounce);
    } else {
      setSuggestions([]);
      setIsOpen(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue, isFocused]);

  const handleSelect = (suggestion) => {
    if (!suggestion || !suggestion.city) return;
    
    justSelected.current = true;

    const selectedCity = suggestion.city.trim();
    setInputValue(selectedCity);
    onSelect(selectedCity);

    setIsOpen(false);
    setSuggestions([]);

    // Allow re-open after short delay
    setTimeout(() => {
      justSelected.current = false;
    }, 200);
  };

  return (
    <div className="autocomplete-container">
      <div className="input-wrapper">
        <input
          type="text"
          className="form-input"
          placeholder="Search your city"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onFocus={() => {
            setIsFocused(true);
            if (inputValue.trim() !== '') setIsOpen(true);
          }}
          onBlur={() => {
            setTimeout(() => {
              if (!justSelected.current) {
                setIsOpen(false);
              }
            }, 100);
          }}
        />
        <FaSearch className="search-icon" />
      </div>

      {isOpen && suggestions.length > 0 && (
        <ul className="suggestions-list">
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              onMouseDown={(e) => {
                e.preventDefault(); // prevents input blur before selection
                handleSelect(suggestion);
              }}
            >
              {suggestion.city}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Autocomplete;
